export const EXTEND_SKU = ';xtd;'
